import { Routes } from '@angular/router';
import { authGuard } from '../guards/auth.guard';
import { clientIdGuard } from '../guards/client-id/client-id.guard';

export const titanRoutes: Routes = [
  {
    path: `titan`,
    canActivate: [authGuard],
    loadComponent: () =>
      import('../components/titan/titan.component').then(
        (m) => m.TitanComponent
      ),
    children: [
      {
        path: `titan-runner-audit`,
        loadComponent: () =>
          import(
            '../components/titan/titan-runner-audit/titan-runner-audit.component'
          ).then((m) => m.TitanRunnerAuditComponent),
        canActivate: [authGuard, clientIdGuard],
      },
      {
        path: `titan-runner-audit/edit`,
        loadComponent: () =>
          import(
            '../components/titan/titan-runner-audit-form/titan-runner-audit-form.component'
          ).then((m) => m.TitanRunnerAuditFormComponent),
        canActivate: [authGuard, clientIdGuard],
      },
      {
        path: 'titan-rac-config',
        loadComponent: () =>
          import('../components/titan/titan-rac/titan-rac.component').then(
            (m) => m.TitanRACComponent
          ),
        canActivate: [authGuard, clientIdGuard],
      },
      {
        path: 'titan-rac-config/edit',
        loadComponent: () =>
          import(
            '../components/create-titan-rac-config/create-titan-rac.component'
          ).then((m) => m.CreateTitanRACComponent),
        canActivate: [authGuard, clientIdGuard],
      },
      {
        path: 'titan-rac-config/create',
        loadComponent: () =>
          import(
            '../components/create-titan-rac-config/create-titan-rac.component'
          ).then((m) => m.CreateTitanRACComponent),
        canActivate: [authGuard, clientIdGuard],
      },
      {
        path: 'titan-runner',
        loadComponent: () =>
          import(
            '../components/titan/titan-runner/titan-runner.component'
          ).then((m) => m.TitanRunnerComponent),
        canActivate: [authGuard, clientIdGuard],
      },
      {
        path: 'titan-process',
        loadComponent: () =>
          import(
            '../components/titan/titan-process/titan-process.component'
          ).then((m) => m.TitanProcessComponent),
        canActivate: [authGuard, clientIdGuard],
      },
      {
        path: 'titan-action',
        loadComponent: () =>
          import(
            '../components/titan/titan-action/titan-action.component'
          ).then((m) => m.TitanActionComponent),
        canActivate: [authGuard, clientIdGuard],
      },
      {
        path: 'titan-source',
        loadComponent: () =>
          import(
            '../components/titan/titan-source/titan-source.component'
          ).then((m) => m.TitanSourceComponent),
        canActivate: [authGuard, clientIdGuard],
      },
    ],
  },
];
